// PsyPractice: hukuki belgeler / Português.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar; aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir;
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "empresário em nome individual";

const OWNER = 'PsyPractice (doravante a "Plataforma" ou o "Responsável pelo Tratamento")';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Termos de Utilização e Exclusão de Responsabilidade",
    description:
      "Natureza e limites do serviço, aquilo que não substitui, compromissos do utilizador e uma renúncia abrangente que atribui toda a responsabilidade ao utilizador.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Partes e Aceitação",
        paras: [
          `Os presentes Termos de Utilização são celebrados entre ${OWNER} e qualquer pessoa singular ou coletiva que aceda à Plataforma ou a utilize (o "Utilizador"). Ao criar uma conta, iniciar sessão ou utilizar a Plataforma de qualquer forma, o Utilizador confirma que leu e compreendeu os presentes Termos e que os aceita e se obriga a cumpri-los de forma incondicional e integral. Quem não aceitar estes Termos não deve utilizar a Plataforma.`,
        ],
      },
      {
        heading: "2. Natureza e Limites do Serviço",
        bullets: [
          "O PsyPractice é um software de SIMULAÇÃO de pacientes assistido por IA que permite a estudantes de psicologia e a clínicos em início de carreira realizar e registar a sua própria prática de entrevista clínica num ambiente seguro.",
          "O PsyPractice não é um serviço de educação ou de ensino; é uma ferramenta de software que permite ao utilizador realizar e registar a sua própria prática. A Plataforma não fornece aulas, currículo, exames ou documentos e não confere qualquer título, qualificação ou habilitação.",
          "O \"paciente\" simulado não é um cliente real; as suas respostas são sintetizadas por inteligência artificial, podem ser erradas, incompletas, incoerentes ou enganadoras e não têm qualquer pretensão de exatidão ou veracidade clínica.",
        ],
      },
      {
        heading: "2.1. Aquilo que a Plataforma Não Substitui",
        bullets: [
          "NÃO é terapia ou aconselhamento real e não substitui nenhuma sessão realizada com um cliente real.",
          "NÃO substitui a supervisão clínica. Os relatórios de feedback produzidos pelo supervisor de IA são texto gerado automaticamente; não constituem parecer de perito, avaliação oficial nem classificação.",
          "NÃO é um instrumento de diagnóstico, rastreio ou avaliação; nenhum resultado da Plataforma pode ser utilizado para diagnóstico ou decisão clínica sobre qualquer pessoa real.",
          "NÃO DEVE ser utilizada em crises ou emergências. Em caso de ideação suicida, risco de dano para o próprio ou para terceiros, ou qualquer emergência comparável, feche a Plataforma e contacte de imediato os serviços de emergência locais ou uma instituição de saúde competente.",
          "NÃO é fonte de competência profissional, licença, título ou autoridade; o tempo passado na Plataforma e os seus resultados não podem ser apresentados a nenhuma instituição como prova de qualificação.",
        ],
      },
      {
        heading: "3. Declarações e Compromissos do Utilizador",
        bullets: [
          "O Utilizador compromete-se a utilizar a Plataforma exclusivamente dentro dos limites legais e éticos, com o objetivo de desenvolver a sua própria prática profissional.",
          "O Utilizador compromete-se a NÃO introduzir dados REAIS de pacientes/clientes, informações identificativas ou dados de saúde de categoria especial pertencentes a qualquer pessoa; todas as consequências legais de o fazer recaem exclusivamente sobre o Utilizador.",
          "O Utilizador compromete-se a não utilizar qualquer resultado obtido na Plataforma para diagnóstico, tratamento, intervenção ou decisão clínica relativos a qualquer pessoa real.",
          "O Utilizador é o único responsável pela sua própria competência profissional, pelo âmbito da sua autoridade e pelo cumprimento da regulamentação profissional e ética aplicável.",
          "A segurança da conta, a confidencialidade da palavra-passe e toda a atividade realizada através da conta do Utilizador são da responsabilidade do Utilizador.",
          "A conta é pessoal; o Utilizador compromete-se a não a partilhar com terceiros e a não utilizar a Plataforma através de meios automatizados (bots, scripts, etc.). A utilização dos planos pagos está sujeita a um limite de utilização justa (atualmente 60 sessões por mês civil), detalhado no Contrato de Venda à Distância.",
        ],
      },
      {
        heading: "4. Toda a Responsabilidade Recai sobre o Utilizador (Renúncia)",
        paras: [
          "A Plataforma é disponibilizada \"TAL COMO ESTÁ\" e \"CONFORME DISPONÍVEL\", sem qualquer garantia expressa ou implícita (incluindo funcionamento ininterrupto, ausência de erros, adequação a um fim específico, exatidão ou atualidade).",
          "O Utilizador aceita e obriga-se a ser EXCLUSIVA e PESSOALMENTE responsável por todos e quaisquer danos diretos, indiretos, incidentais, especiais ou consequenciais (incluindo danos patrimoniais, morais, de reputação profissional, de perda de dados, de perda de receitas e danos causados a terceiros) decorrentes da utilização ou da impossibilidade de utilização da Plataforma, da confiança depositada nos resultados da IA ou da aplicação desses resultados de qualquer forma.",
          "Na medida máxima permitida pela lei aplicável, o Utilizador RENUNCIA pelo presente, de forma irrevogável e incondicional, desde já e antecipadamente, a todas e quaisquer reclamações, ações judiciais e direitos de indemnização que possa vir a invocar contra a Plataforma, os seus proprietários, colaboradores, programadores, parceiros comerciais e prestadores de serviços relativamente a qualquer prejuízo que possa sofrer em caso de resultado adverso.",
          "O Utilizador compromete-se ainda a manter a Plataforma totalmente indemne (indemnizar) de todas e quaisquer reclamações, danos, sanções e custos (incluindo honorários de advogados) caso a Plataforma seja interpelada por qualquer terceiro ou instituição devido a culpa, negligência ou utilização em violação dos presentes Termos por parte do Utilizador.",
        ],
      },
      {
        heading: "5. Limitação de Responsabilidade",
        paras: [
          "Sem prejuízo das disposições imperativas da lei aplicável, a responsabilidade legal total da Plataforma fica, em qualquer caso, limitada ao montante efetivamente pago pelo Utilizador à Plataforma nos 12 meses anteriores ao facto que deu origem à reclamação em causa. Quando a utilização for gratuita, este montante é zero.",
        ],
      },
      {
        heading: "6. Propriedade Intelectual, Alterações e Cessação",
        bullets: [
          "Todos os direitos de propriedade intelectual sobre a Plataforma, o seu software, o seu design, os modelos de casos de pacientes e os conteúdos pertencem à Plataforma.",
          "Todos os direitos patrimoniais de propriedade intelectual transmissíveis sobre qualquer conteúdo que o Utilizador crie na Plataforma (incluindo as mensagens de terapeuta que escreve, as transcrições das sessões e os materiais delas derivados) consideram-se cedidos à Plataforma, de forma exclusiva, perpétua e sem contrapartida, no momento em que esse conteúdo é criado; a Plataforma pode utilizar, reproduzir e tratar esse conteúdo em todo o mundo e sem restrições, para qualquer finalidade, incluindo a operação do serviço, a geração de feedback e a melhoria e o desenvolvimento do sistema (incluindo a melhoria por aprendizagem automática). Os direitos do Utilizador em matéria de dados pessoais ao abrigo da legislação de proteção de dados aplicável (RGPD / KVKK) não são afetados por esta cessão e mantêm-se reservados.",
          "A Plataforma reserva-se o direito de alterar, suspender ou descontinuar os presentes Termos e o âmbito do serviço a qualquer momento, sem aviso prévio.",
          "Em caso de violação dos presentes Termos, a Plataforma pode suspender ou encerrar a conta sem aviso prévio.",
        ],
      },
      {
        heading: "7. Lei Aplicável e Jurisdição",
        paras: [
          "Os presentes Termos regem-se pelas leis da República da Turquia. Os tribunais e as instâncias de execução da República da Turquia são competentes para qualquer litígio que possa surgir.",
          "Para os consumidores residentes na União Europeia, ficam ressalvadas as proteções conferidas pelas disposições imperativas de defesa do consumidor do seu país de residência e pelos seus direitos de proteção de dados ao abrigo do RGPD; esta escolha de lei não prevalece sobre essas disposições imperativas.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Política de Privacidade",
    description:
      "O RGPD como norma de base; dados tratados, fundamentos jurídicos, alojamento na UE, transferências internacionais (fornecedor de IA) e a cláusula de transferência transfronteiriça do art. 9.º da KVKK para os utilizadores na Turquia.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `A presente Política de Privacidade explica como os dados pessoais são tratados no âmbito da Plataforma operada por ${OWNER}. Como norma de base em matéria de proteção de dados, a política segue o Regulamento Geral sobre a Proteção de Dados da UE (RGPD / 2016/679); para os utilizadores localizados na Turquia, aplica-se adicionalmente a Lei turca de Proteção de Dados Pessoais n.º 6698 (KVKK), em particular o artigo 9.º sobre transferências para o estrangeiro. O Aviso Informativo KVKK e a Declaração de Consentimento Explícito são parte integrante desta política.`,
        ],
      },
      {
        heading: "Responsável pelo tratamento e local de alojamento",
        bullets: [
          "Responsável pelo tratamento: PsyPractice. Os pedidos dos titulares dos dados são tratados através do canal de contacto divulgado na Plataforma (e-mail de contacto: info@psycora.com).",
          "Alojamento: a Plataforma e a sua base de dados estão alojadas na União Europeia, num centro de dados nos Países Baixos (Oracle Cloud). Para os utilizadores localizados na UE/EEE, os dados são tratados e armazenados dentro da UE.",
          "O fornecedor de alojamento atua exclusivamente como subcontratante, ao abrigo de um Acordo de Tratamento de Dados (DPA) celebrado.",
        ],
      },
      {
        heading: "Dados recolhidos",
        bullets: [
          "Dados da conta: nome, e-mail, palavra-passe com hash, informação sobre subscrição/plano.",
          "Dados de utilização: sessões criadas, transcrições das sessões, casos de pacientes gerados, relatórios de feedback do supervisor.",
          "Dados técnicos: registos de sessão, IP, preferência de navegador/idioma, registos de limitação de pedidos e de segurança.",
        ],
      },
      {
        heading: "Finalidades do tratamento e fundamento jurídico (art. 6.º do RGPD)",
        bullets: [
          "Execução de um contrato (art. 6.º, n.º 1, alínea b)): criação da conta, realização de sessões, memória do paciente entre sessões, avaliação do supervisor, gestão da subscrição e dos limites de utilização.",
          "Interesse legítimo (art. 6.º, n.º 1, alínea f)): segurança, prevenção de abusos, melhoria do sistema e depuração.",
          "Obrigação legal (art. 6.º, n.º 1, alínea c)): conservação/comunicação decorrente da legislação.",
          "Consentimento (art. 6.º, n.º 1, alínea a)): tratamento para fins de análise/melhoria do produto que não seja estritamente necessário ao serviço e, quando exigido, transferência para fora da UE/EEE.",
        ],
      },
      {
        heading: "Transferências internacionais",
        paras: [
          "Como o alojamento se situa na UE (Países Baixos), os dados dos utilizadores da UE/EEE são, por regra, tratados dentro da UE, sem transferência para um país terceiro nessa camada. No entanto, para gerar as respostas de IA, o conteúdo das sessões e os prompts são transmitidos ao fornecedor do serviço de IA (Anthropic), cuja infraestrutura de tratamento pode situar-se fora da UE/EEE (p. ex., nos Estados Unidos).",
          "Essas transferências para fora da UE/EEE assentam em garantias adequadas nos termos dos artigos 44.º e seguintes do RGPD, em particular as Cláusulas Contratuais-Tipo (CCT) da Comissão Europeia, e é celebrado um acordo de tratamento de dados (DPA) com o fornecedor. A Plataforma NÃO vende dados pessoais para fins de marketing; os dados não são partilhados com terceiros exceto quando estritamente necessário para operar o serviço (ressalvados os pedidos legítimos das autoridades competentes).",
        ],
      },
      {
        heading: "Para os utilizadores na Turquia: art. 9.º da KVKK (transferência para o estrangeiro)",
        paras: [
          "Os dados pessoais dos utilizadores localizados na Turquia são transferidos para fora da Turquia porque o alojamento se situa nos Países Baixos (UE), e podem também ser transferidos para a Anthropic para tratamento por IA. Estas transferências enquadram-se no art. 9.º da KVKK e assentam em garantias adequadas (o contrato-tipo / compromisso publicado pelo Conselho) ou, quando exigido, no seu consentimento explícito. O âmbito, os destinatários e a finalidade da transferência são detalhados no Aviso Informativo KVKK e na Declaração de Consentimento Explícito.",
        ],
      },
      {
        heading: "Direitos dos titulares dos dados (art. 15.º a 22.º do RGPD)",
        bullets: [
          "Acesso, retificação, apagamento ('direito a ser esquecido') e limitação do tratamento.",
          "Portabilidade dos dados: receber os dados que forneceu num formato estruturado, de uso corrente e de leitura automática.",
          "Oposição: opor-se ao tratamento baseado no interesse legítimo e ao marketing direto.",
          "Direitos relativos a decisões individuais exclusivamente automatizadas/definição de perfis.",
          "Retirar o consentimento a qualquer momento, no tratamento baseado no consentimento (a retirada não afeta a licitude do tratamento efetuado até esse momento).",
          "O direito de apresentar reclamação a uma autoridade de controlo: a autoridade de proteção de dados competente na UE; a Autoridade de Proteção de Dados Pessoais (KVKK) na Turquia.",
        ],
      },
      {
        heading: "Conservação e segurança",
        bullets: [
          "Os dados são conservados enquanto a finalidade do tratamento o exigir e pelos prazos previstos na lei aplicável; findo o prazo, são apagados ou anonimizados.",
          "Os campos sensíveis (p. ex., a palavra-passe, os códigos de verificação e de reposição) são mantidos encriptados/com hash; o acesso é baseado em permissões.",
          "Como nenhum método de transmissão ou armazenamento é 100% seguro, não é possível garantir segurança absoluta.",
        ],
      },
      {
        heading: "Proibição de dados de pacientes reais",
        paras: [
          "A Plataforma é um software de simulação; é proibido introduzir dados pessoais/de saúde pertencentes a clientes reais. Toda a responsabilidade decorrente da introdução de dados pelo Utilizador em violação desta proibição recai exclusivamente sobre o Utilizador.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "Aviso Informativo KVKK",
    description:
      "Responsável pelo tratamento, finalidades do tratamento, fundamento jurídico, transferência e direitos dos titulares dos dados nos termos do artigo 10.º da Lei n.º 6698.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Responsável pelo Tratamento",
        paras: [
          `Nos termos do artigo 10.º da Lei turca de Proteção de Dados Pessoais n.º 6698 ("KVKK"), os seus dados pessoais são tratados por ${OWNER}, na qualidade de Responsável pelo Tratamento, no âmbito descrito abaixo.`,
        ],
      },
      {
        heading: "Dados tratados e finalidades",
        bullets: [
          "Identidade/Contacto (nome, e-mail): criação da conta, autenticação, comunicação.",
          "Transação do cliente (subscrição, plano, utilização): prestação do serviço, faturação, aplicação de limites.",
          "Segurança das transações (sessão, IP, registos): segurança, prevenção de abusos, obrigação legal.",
          "Conteúdo do utilizador (transcrições das sessões, casos gerados): prestação do serviço de software e geração de feedback.",
          "Pertença a uma turma institucional (identificador da turma, período de pertença): quando o utilizador entra numa turma gerida por uma instituição, visibilidade do orientador e administração da turma.",
        ],
      },
      {
        heading: "Fundamento jurídico (art. 5.º)",
        bullets: [
          "Celebração/execução de um contrato: dados necessários à prestação do serviço.",
          "Interesse legítimo do responsável pelo tratamento: segurança, prevenção de fraude, melhoria do sistema.",
          "Obrigação legal: conservação/comunicação decorrente da legislação.",
          "Consentimento explícito: transferência para o estrangeiro (art. 9.º) e tratamento adicional não estritamente necessário ao serviço.",
        ],
      },
      {
        heading: "Transferência para o estrangeiro (art. 9.º)",
        paras: [
          "Como a Plataforma e a sua base de dados estão alojadas na União Europeia, num centro de dados nos Países Baixos (Oracle Cloud), os dados pessoais dos utilizadores localizados na Turquia são transferidos para fora da Turquia (para a UE). Além disso, para gerar as respostas de IA, o conteúdo das sessões e os prompts podem ser transferidos para o fornecedor do serviço de IA (Anthropic), cuja infraestrutura de tratamento pode situar-se fora da UE/EEE (p. ex., nos Estados Unidos).",
          "Estas transferências para o estrangeiro enquadram-se no art. 9.º da KVKK e assentam em garantias adequadas, como o contrato-tipo / compromisso publicado pelo Conselho, ou, quando exigido, no seu consentimento explícito. São celebrados acordos de tratamento de dados (DPA) com os fornecedores de alojamento e de serviços.",
        ],
      },
      {
        heading: "Turmas institucionais e visibilidade do orientador",
        paras: [
          "Se entrar numa turma aberta por uma universidade, clínica ou instituição semelhante, o conteúdo das suas sessões (transcrições) e os relatórios do supervisor podem ser vistos pelo orientador dessa turma durante o período da turma. Esta visibilidade abrange apenas as suas sessões associadas à turma e termina quando a sua pertença à turma termina.",
          "Este acesso é obtido através de um ecrã de consentimento explícito SEPARADO, apresentado quando entra na turma; não faz parte da aceitação geral da Plataforma. Se não der esse consentimento, não pode entrar na turma, mas pode continuar a utilizar a Plataforma individualmente exatamente como antes. A retirada do consentimento põe termo à sua pertença à turma e não afeta a sua utilização individual.",
        ],
      },
      {
        heading: "Direitos dos titulares dos dados (art. 11.º)",
        bullets: [
          "Saber se os seus dados pessoais são tratados e, em caso afirmativo, solicitar informação a esse respeito.",
          "Conhecer a finalidade do tratamento e saber se os dados são utilizados em conformidade com essa finalidade.",
          "Conhecer os terceiros a quem os dados são transferidos, no país ou no estrangeiro.",
          "Solicitar a retificação de tratamento incompleto/incorreto e, quando estiverem reunidas as condições, o apagamento/destruição.",
          "Opor-se a um resultado desfavorável decorrente exclusivamente de análise automatizada.",
          "Exigir indemnização por danos sofridos devido a tratamento ilícito.",
        ],
      },
      {
        heading: "Pedidos",
        paras: [
          "Pode apresentar pedidos relativos aos seus direitos através do canal de contacto divulgado pelo Responsável pelo Tratamento. Os pedidos são concluídos nos prazos previstos na KVKK e na sua legislação complementar.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Declaração de Consentimento Explícito",
    description:
      "Separada do aviso informativo; consentimento livremente dado para a transferência para o estrangeiro e para o tratamento por IA.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Declaro que li e compreendi o Aviso Informativo KVKK e que consinto, de forma livre, informada e explícita, no tratamento descrito abaixo. (Nos termos da decisão do Conselho KVKK n.º 2018/90, o consentimento explícito é obtido separadamente do dever de informação.)",
        ],
      },
      {
        heading: "Tratamento consentido",
        bullets: [
          "Transferência dos meus dados pessoais para fora da Turquia, e o seu armazenamento e tratamento aí, por a Plataforma estar alojada na União Europeia (Países Baixos / Oracle Cloud) (art. 9.º da KVKK).",
          "Transferência e tratamento das transcrições das minhas sessões e dos meus prompts junto do fornecedor do serviço de IA (Anthropic), cuja infraestrutura de tratamento pode situar-se fora da UE/EEE, para efeitos de geração de respostas de IA (art. 9.º da KVKK).",
          "Tratamento para fins de melhoria do produto e de análise que não seja estritamente necessário à prestação do serviço.",
          "Receção de notificações relacionadas com o serviço.",
        ],
      },
      {
        heading: "Retirada do consentimento",
        paras: [
          "Compreendo que posso retirar o meu consentimento explícito a qualquer momento; contudo, como a transferência para o estrangeiro, para o fornecedor de IA, é tecnicamente necessária ao funcionamento do serviço, aceito que a retirada deste consentimento possa ter como consequência a impossibilidade de utilizar as funcionalidades em causa ou o serviço no seu todo. A retirada não afeta a licitude do tratamento efetuado até à data da retirada.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice; see the comment there.
    id: "outreach",
    title: "Aviso sobre Comunicações de Contacto Institucional",
    description:
      "Para académicos e contactos institucionais que receberam um e-mail de contacto institucional: de onde vieram os dados, porque são tratados, o fundamento jurídico e como recusar.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "O presente aviso informa os destinatários dos e-mails de contacto institucional enviados pelo PsyPractice a departamentos universitários de psicologia e ao seu pessoal académico, nos termos do artigo 10.º da Lei turca de Proteção de Dados Pessoais n.º 6698 (KVKK) e do Comunicado sobre os Procedimentos e Princípios do Cumprimento do Dever de Informação. Como os seus dados pessoais não foram obtidos diretamente junto de si, a informação é prestada, o mais tardar, no momento do primeiro contacto, razão pela qual o e-mail de contacto remete para aqui.",
        ],
      },
      {
        heading: "1. Responsável pelo tratamento",
        bullets: [
          `Nome: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Morada: ${MERCHANT.addressEn}`,
          `Repartição de finanças / n.º: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Dados tratados e sua origem",
        paras: [
          "O tratamento limita-se a dados de contacto profissional: nome, título académico, universidade e departamento, endereço de e-mail institucional e, quando publicado, número de telefone institucional.",
          "Estes dados não foram recolhidos junto de si, mas compilados a partir das páginas oficiais de departamentos e faculdades publicadas pelas universidades. Não são tratadas categorias especiais de dados, e os endereços de e-mail privados (não institucionais) não são utilizados para contacto.",
        ],
      },
      {
        heading: "3. Finalidade",
        paras: [
          "Os seus dados são tratados para apresentar uma ferramenta de software concebida para o percurso académico em psicologia, para convidar o seu departamento a uma eventual conversa sobre um piloto ou uma cooperação e para conduzir a correspondência correspondente. Não são utilizados para qualquer outra finalidade, não são vendidos nem transferidos a terceiros para fins de marketing.",
        ],
      },
      {
        heading: "4. Fundamento jurídico",
        paras: [
          "O tratamento assenta nos interesses legítimos do responsável pelo tratamento, nos termos do artigo 5.º/2-(f) da KVKK, desde que não prejudique os seus direitos e liberdades fundamentais: o contacto é feito apenas para um endereço institucional, apenas sobre um assunto diretamente relacionado com a área profissional do destinatário e um número limitado de vezes.",
          "O simples facto de os dados estarem publicamente disponíveis online não constitui, por si só, um fundamento jurídico. O Conselho de Proteção de Dados Pessoais entendeu que o facto de os dados serem públicos não os torna utilizáveis para qualquer finalidade e que a intenção e a finalidade da sua publicação devem ser avaliadas separadamente; por isso, não se invoca o artigo 5.º/2-(d).",
        ],
      },
      {
        heading: "5. Transferências e conservação",
        paras: [
          "A correspondência é conduzida através de um fornecedor de e-mail cuja infraestrutura pode situar-se no estrangeiro; essas transferências são feitas com garantias adequadas nos termos do artigo 9.º da KVKK.",
          "Os seus dados são apagados quando a finalidade do contacto cessa ou a seu pedido. Após um pedido de apagamento, é mantido um registo de 'não contactar', estritamente limitado, apenas para garantir que não volta a ser contactado; nunca é utilizado para contacto.",
        ],
      },
      {
        heading: "6. Comunicações eletrónicas comerciais e direito de recusa",
        paras: [
          "As mensagens promocionais enquadram-se no âmbito da Lei n.º 6563 sobre a Regulação do Comércio Eletrónico. Pode recusar recebê-las sem indicar qualquer motivo; as recusas são processadas no prazo máximo de três dias úteis, após o que não é enviada mais nenhuma mensagem promocional. Basta responder ao e-mail recebido ou escrever para " + MERCHANT.email + ".",
        ],
      },
      {
        heading: "7. Os seus direitos",
        paras: [
          "Nos termos do artigo 11.º da KVKK, tem o direito de saber se os seus dados pessoais são tratados, de solicitar informação a esse respeito, de conhecer a finalidade do tratamento e saber se os dados são utilizados em conformidade, de conhecer os terceiros a quem são transferidos na Turquia ou no estrangeiro, de solicitar a correção de dados incompletos ou inexatos, de solicitar o apagamento ou a destruição, de solicitar que estas ações sejam comunicadas a terceiros, de se opor a um resultado desfavorável produzido exclusivamente por análise automatizada e de exigir indemnização por danos sofridos.",
          `Os pedidos podem ser enviados para ${MERCHANT.email} e são respondidos no prazo máximo de trinta dias. Mantém igualmente o direito de apresentar reclamação ao Conselho de Proteção de Dados Pessoais.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Política de Cookies",
    description: "Tipos de cookies utilizados, as suas finalidades e a gestão de preferências.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "A Plataforma utiliza cookies e tecnologias semelhantes de armazenamento local (localStorage) para manter a sua sessão e memorizar as suas preferências.",
        ],
      },
      {
        heading: "Tecnologias utilizadas",
        bullets: [
          "Estritamente necessários: token de sessão/autenticação, segurança. O serviço não funciona sem eles.",
          "Funcionais: preferência de idioma/região (NEXT_LOCALE), preferências de interface (p. ex., tema).",
          "Desempenho/segurança: registos técnicos para limitação de pedidos e deteção de abusos.",
        ],
      },
      {
        heading: "Gestão de preferências",
        paras: [
          "Pode eliminar ou bloquear os cookies no seu navegador; contudo, bloquear os cookies estritamente necessários impede o início de sessão e as funcionalidades essenciais. Em conformidade com os princípios do RGPD / ePrivacy e com o Guia de Cookies da KVKK, os cookies não essenciais só são utilizados com base na sua preferência/consentimento explícito.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "Sobre Nós",
    description:
      "A finalidade do PsyPractice, o serviço que oferece e os dados de contacto do comerciante (vendedor).",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "O PsyPractice é uma plataforma de simulação de pacientes e de competências clínicas assistida por IA, concebida para estudantes de psicologia e para clínicos recém-licenciados, em início de carreira. Os utilizadores realizam sessões de terapia por texto; no fim de cada sessão, um supervisor de IA avalia a conversa e produz um relatório de feedback orientado para o desenvolvimento. O paciente de IA leva a relação terapêutica de sessão para sessão através de uma memória entre sessões.",
        ],
      },
      {
        heading: "A nossa missão",
        paras: [
          "O nosso objetivo é dar aos futuros profissionais de saúde mental um ambiente seguro e repetível onde possam praticar competências de entrevista sem qualquer risco de prejudicar clientes reais. O PsyPractice não é um serviço de educação ou de ensino; é uma ferramenta de software que permite ao utilizador realizar e registar a sua própria prática. Não é terapia ou aconselhamento real, não substitui a supervisão clínica, não é um instrumento de diagnóstico ou avaliação e não deve ser utilizado em crises ou emergências.",
        ],
      },
      {
        heading: "O que oferecemos",
        bullets: [
          "Simulação de sessões de terapia por texto com diversos perfis de pacientes sintetizados a partir da literatura clínica.",
          "Relatórios de avaliação automatizados do supervisor depois de cada sessão.",
          "Um modelo de 'paciente vivo' com memória entre sessões, que desenvolve a relação terapêutica ao longo do tempo.",
          "Geração de pacientes personalizados, permitindo aos estudantes criar os seus próprios casos de IA.",
          "Métricas de progresso que acompanham o desenvolvimento das microcompetências.",
        ],
      },
      {
        heading: "Informação do Vendedor / da Empresa",
        bullets: [
          `Denominação comercial: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Morada: ${MERCHANT.addressEn}`,
          `Repartição de finanças / n.º: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Contrato de Venda à Distância",
    description:
      "Vendedor, comprador, serviço, preço, pagamento, execução e condições do direito de livre resolução nos termos da Lei turca n.º 6502 e do Regulamento dos Contratos à Distância.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Partes",
        bullets: [
          `VENDEDOR: ${MERCHANT.legalName} (${OWNER_TYPE}). Morada: ${MERCHANT.addressEn}. Repartição de finanças/n.º: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. E-mail: ${MERCHANT.email}.`,
          "COMPRADOR: a pessoa singular ou coletiva que cria uma conta na Plataforma e adquire uma subscrição paga (o \"Comprador\").",
        ],
      },
      {
        heading: "2. Objeto do Contrato",
        paras: [
          "O presente Contrato tem por objeto determinar os direitos e as obrigações das partes, em conformidade com a Lei turca n.º 6502 de Defesa do Consumidor e com o Regulamento dos Contratos à Distância, relativamente à venda e à execução da subscrição de serviço digital adquirida eletronicamente pelo Comprador através da Plataforma, cujas características e preço de venda se indicam abaixo.",
        ],
      },
      {
        heading: "3. Natureza do Serviço e Preço",
        bullets: [
          "O serviço vendido consiste nas funcionalidades de simulação de pacientes assistida por IA oferecidas ao abrigo de um plano de subscrição pago do software PsyPractice (um serviço digital / direito de utilização do software).",
          "O PsyPractice não é um serviço de educação ou de ensino; é uma ferramenta de software que permite ao utilizador realizar e registar a sua própria prática. O valor da subscrição é a contrapartida pelo acesso a esse software; não é um pagamento por aulas, currículo, exames, consultoria ou qualquer documento.",
          "O conteúdo do plano, a duração (mensal, um período de 4 meses ou anual) e o preço em vigor são apresentados claramente no ecrã de preços/pagamento da Plataforma no momento da compra; o montante total com impostos incluídos é comunicado ao Comprador antes do pagamento.",
          "Os preços aplicam-se na moeda apresentada na Plataforma; salvo cancelamento, a subscrição renova-se automaticamente ao mesmo preço no fim do período selecionado.",
          "Nos planos oferecidos como «sessões ilimitadas», a utilização está sujeita a um limite de utilização justa (atualmente 60 sessões por mês civil). Atingido o limite, podem ser iniciadas novas sessões a partir do primeiro dia do mês civil seguinte; tal não dá lugar a qualquer redução de preço ou reembolso. O limite existe para impedir a partilha de contas e a utilização automatizada, e o Vendedor não o altera em prejuízo do Comprador durante um período de subscrição já pago.",
        ],
      },
      {
        heading: "4. Pagamento",
        paras: [
          "Os pagamentos são cobrados de forma segura por cartão de crédito/débito através da instituição de pagamento licenciada iyzico. Os dados do cartão não são armazenados pelo Vendedor; o pagamento é processado através dos sistemas seguros da iyzico. Nos pagamentos recorrentes (subscrição), o montante é cobrado automaticamente, em cada período de renovação, no cartão aprovado pelo Comprador.",
        ],
      },
      {
        heading: "5. Execução e Entrega",
        paras: [
          "O serviço é digital e não envolve qualquer entrega física. Após a confirmação do pagamento, as funcionalidades da subscrição ficam imediatamente disponíveis na conta do Comprador. A execução realiza-se por via eletrónica, através da disponibilização de acesso ininterrupto durante toda a duração da subscrição.",
        ],
      },
      {
        heading: "6. Direito de Livre Resolução e Respetiva Exceção",
        bullets: [
          "Nos termos do artigo 15.º/1-(ğ) do Regulamento dos Contratos à Distância, o direito de livre resolução não pode ser exercido relativamente a bens/serviços incorpóreos (digitais) executados instantaneamente por via eletrónica, cuja execução tenha começado com o consentimento do Comprador.",
          "O Comprador reconhece, no momento da compra, que o serviço será executado de imediato e que, por isso, não existe direito de livre resolução. O Comprador pode cancelar a subscrição a qualquer momento para impedir a renovação; o cancelamento produz efeitos no fim do período pago em curso.",
          "Para as condições detalhadas de reembolso, consulte as \"Condições de Entrega e Reembolso\".",
        ],
      },
      {
        heading: "7. Litígios e Entrada em Vigor",
        paras: [
          "Em caso de litígio, o Comprador pode recorrer à Comissão de Arbitragem de Consumo ou aos Tribunais de Consumo do seu local de residência, dentro dos limites monetários anunciados pelo Ministério do Comércio. O presente Contrato é celebrado e entra em vigor com a aprovação do Comprador por via eletrónica.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Condições de Entrega e Reembolso",
    description:
      "Entrega do serviço digital, cancelamento da subscrição, exceção ao direito de livre resolução e condições de reembolso.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Entrega (Serviço Digital)",
        bullets: [
          "O PsyPractice é um serviço inteiramente digital; não há envio de produto físico nem entrega por transportadora.",
          "No momento em que o pagamento é confirmado, as funcionalidades da subscrição são ativadas automática e instantaneamente na conta do Comprador; não há prazo de entrega nem custo de entrega separados.",
          "O serviço é acedido através do navegador web de qualquer dispositivo com ligação à internet.",
        ],
      },
      {
        heading: "Cancelamento da Subscrição",
        bullets: [
          "O Comprador pode cancelar a subscrição a qualquer momento nas definições da conta. O cancelamento produz efeitos no fim do período pago em curso e impede a renovação automática seguinte.",
          "Após o cancelamento, o acesso ao serviço mantém-se durante o resto do período pago.",
        ],
      },
      {
        heading: "Direito de Livre Resolução e Reembolso",
        bullets: [
          "Como o serviço é um serviço digital executado de imediato com o consentimento do Comprador, por regra não existe direito de livre resolução e, portanto, não existe direito a reembolso, nos termos do artigo 15.º/1-(ğ) do Regulamento dos Contratos à Distância.",
          "Em casos de defeito manifesto, como uma cobrança errada/duplicada, a impossibilidade total de aceder ao serviço por razões técnicas ou situações semelhantes, o Comprador pode solicitar o reembolso contactando o Vendedor num prazo razoável a contar da data do pagamento.",
          `Os pedidos de reembolso são enviados para ${MERCHANT.email}; os reembolsos aprovados são devolvidos ao cartão utilizado no pagamento através da infraestrutura da iyzico, por regra no prazo de 14 dias. O prazo de reembolso pode variar consoante o tempo de processamento do banco.`,
        ],
      },
      {
        heading: "Contacto",
        paras: [
          `Para todas as questões de entrega, cancelamento e reembolso: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
